import { useEffect } from "react"

/** Открытые модальные слои Radix: пока они есть, pointer-events: none на body законный. */
const OPEN_LAYER =
	'[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [role="menu"][data-state="open"]'

/**
 * Страховка от зависшей страницы: Radix иногда не возвращает pointer-events у body,
 * когда один слой (меню) открывает другой (диалог) и оба закрываются. Если слоёв нет,
 * а body всё ещё «не кликается», снимаем блокировку.
 */
export function usePointerEventsGuard() {
	useEffect(() => {
		let frame = 0
		const release = () => {
			cancelAnimationFrame(frame)
			// Кадр после закрытия: Radix успевает снять блокировку сам, если может.
			frame = requestAnimationFrame(() => {
				if (document.body.style.pointerEvents !== "none") return
				if (document.querySelector(OPEN_LAYER)) return
				document.body.style.pointerEvents = ""
			})
		}
		const observer = new MutationObserver(release)
		observer.observe(document.body, { attributes: true, attributeFilter: ["style"] })
		observer.observe(document.body, { childList: true })
		return () => {
			cancelAnimationFrame(frame)
			observer.disconnect()
		}
	}, [])
}
